<template>
  <div class="box">
    <div class="content-warp main-width">
      <a-spin :spinning="loading">
        <ul v-if="data.length > 0" style="padding: 0;">
          <li @click="rowClick(item.id)" class="clearFloat" v-for="(item,index) in data" :key="index">
            <span class="title">
              <b class="dot">&bull;</b>
              {{ item.title }}
            </span>
            <span class="time">{{ matchFun.formatDate(item.updateTime, false) }}</span>
          </li>
        </ul>
      </a-spin>
      <div v-if="data.length == 0" style="margin-top: 50px;">
        <a-empty>
          <span slot="description" style="color:#c1bebe;"> 暂无数据</span>
        </a-empty>
      </div>
    </div>
  </div>
</template>
<script>
import matchFun from '@comm/utils/matchFun'
export default {
  name: 'Home',
  mounted () {
    // 初始化
    this.queryData()
  },
  data () {
    return {
      matchId: Number(this.$route.query.matchId),
      programId: Number(this.$route.query.programId),
      matchFun: matchFun,
      loading: false,
      data: [],
      pageNum: 1,
      pageSize: 10,
      hasMore: false
    }
  },
  methods: {
    rowClick (id) {
      this.$router.push({path: '/MatchNoticeDetail', query: {matchId: this.matchId, programId: this.programId, id: id}})
    },
    queryData () {
      this.loading = true
      this.$api.match.matchNotices({matchId: this.matchId}).then(res => {
        this.loading = false
        if (res.status === 0) {
          this.data = res.data
        } else {
          this.$message.error(res.msg)
        }
      }).catch(err => {
        console.log(err)
      })
    }
  }
}
</script>
<style lang="scss" scoped>
.box {
  background: #fff;
}
.main-width {
  width: 1200px;
  margin-left: auto;
  margin-right: auto;
}
.content-warp{
  padding: 50px 0;
  .more {
    color: #000;
    text-align: center;
    font-weight: bold;
    line-height: 30px;
    margin-top: 30px;
    font-size: 16px;
    cursor: pointer;
  }
}
li{
  cursor: pointer;
  line-height: 50px;
  overflow: hidden;
  list-style-type:none;
  border-bottom: 3px solid #f4f4f4;
  .dot{
    color: #bdbdbd;
    padding: 0 8px;
  }
  span{
    float: left;
    display: block;
    color: #333333;
  }
  span.title{
    font-size: 18px;
    font-weight: bold;
    width: 90%;
    overflow: hidden;
    text-overflow:ellipsis;
    white-space: nowrap;
  }
  span.time{
    font-size: 14px;
    width: 10%;
    text-align: right;
  }
}
</style>



// WEBPACK FOOTER //
// src/comm/components/MatchNotice.vue